import { render, staticRenderFns } from "./saveChangesDialog.vue?vue&type=template&id=59ad710c&scoped=true"
import script from "./saveChangesDialog.vue?vue&type=script&lang=js"
export * from "./saveChangesDialog.vue?vue&type=script&lang=js"
import style0 from "./saveChangesDialog.vue?vue&type=style&index=0&id=59ad710c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ad710c",
  null
  
)

export default component.exports